import React from "react";

const ReturnPrint58 = ({ data }) => {
    if (!data) return null;

    const dateObj = new Date(data.createdAt);
    const date = dateObj.toLocaleDateString();
    const time = dateObj.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
    });

    const totalRefund =
        (data.totalBaseAmount || 0) +
        (data.totalCGST || 0) +
        (data.totalSGST || 0);

    return (
        <div
            style={{
                width: "58mm",
                padding: "4px 6px",
                fontFamily: "'Courier New', monospace",
                fontSize: "11px",
                lineHeight: "1.25",
                color: "#000"
            }}
        >
            {/* HEADER */}
            <div style={{ textAlign: "center" }}>
                <img
                    src="/assets/mayura.png"
                    alt="Logo"
                    style={{ width: "42px", marginBottom: "4px" }}
                />

                <div style={{ fontWeight: "bold", fontSize: "13px" }}>MAYURA</div>
                <div style={{ fontSize: "11px" }}>SILK & FASHION</div>
                <div style={{ fontSize: "10px" }}>
                    #171 Paneer Nagar, Mogappair<br />
                    Chennai - 600037<br />
                    Ph: 950010555
                </div>

                <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />
            </div>

            {/* RETURN INFO */}
            <div style={{ fontSize: "10px", marginBottom: "6px" }}>
                <div><b>Return No:</b> {data.returnNo}</div>
                <div><b>Invoice No:</b> {data.invoiceNo}</div>
                <div><b>Date:</b> {date} {time}</div>
            </div>

            {/* CUSTOMER */}
            <div style={{ fontSize: "10px", marginBottom: "6px" }}>
                <div><b>Name:</b> {data.customerName}</div>
                <div><b>Phone:</b> {data.customerPhone}</div>
            </div>

            <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />

            {/* ITEMS */}
            <table style={{ width: "100%", fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th style={{ textAlign: "left" }}>Item</th>
                        <th style={{ textAlign: "center" }}>Qty</th>
                        <th style={{ textAlign: "right" }}>Amt</th>
                    </tr>
                </thead>
                <tbody>
                    {data.items.map((item, idx) => (
                        <tr key={idx}>
                            <td style={{ maxWidth: "80px", wordBreak: "break-word" }}>
                                {item.name}
                            </td>
                            <td style={{ textAlign: "center" }}>
                                {item.qtyReturned}
                            </td>
                            <td style={{ textAlign: "right" }}>
                                ₹{(item.qtyReturned * item.rate).toFixed(2)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />

            {/* MINI GST SUMMARY */}
            <div style={{ fontSize: "10px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>Taxable Value</span>
                    <span>₹{data.totalBaseAmount.toFixed(2)}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>CGST</span>
                    <span>₹{data.totalCGST.toFixed(2)}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>SGST</span>
                    <span>₹{data.totalSGST.toFixed(2)}</span>
                </div>
            </div>

            <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />

            {/* TOTAL */}
            <div
                style={{
                    fontSize: "11px",
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "space-between"
                }}
            >
                <span>Total Refund</span>
                <span>₹{totalRefund.toFixed(2)}</span>
            </div>

            {data.refundToWallet && (
                <div style={{ fontSize: "9px", marginTop: "4px" }}>
                    (Credited to Customer Wallet)
                </div>
            )}

            {/* FOOTER */}
            <div style={{ textAlign: "center", fontSize: "9px", marginTop: "8px" }}>
                Returned items accepted as per policy.<br />
                *** THANK YOU – VISIT AGAIN ***
            </div>
        </div>
    );
};

export default ReturnPrint58;
